module.exports = __webpack_public_path__ + "images/a9121eae016034d4dc5cc586b69a28c8.png";